import {
  ExecutionStatRecord,
  FlowStatRecord,
  StatRecord,
  StorageStatRecord,
} from "@dashboard-v3/api";
import dayjs from "dayjs";

type TimestampDate = { date: number };
type StatsToReduce =
  | ExecutionStatRecord[]
  | FlowStatRecord[]
  | StorageStatRecord[];
type StatKey = "executions" | "flow" | "storage";
type StatReducer<T> = (totals: T, stat: StatsToReduce) => T;

export default function process90Days<Totals>(
  data: StatRecord[],
  stat: StatKey,
  init: () => Totals,
  statReducer: StatReducer<Totals>
): Array<TimestampDate & Totals> {
  const today = dayjs().utc().startOf("day");
  const ts90DaysAgo = today.subtract(90, "days").startOf("day").valueOf();
  const tsToday = today.valueOf();
  const result: Array<TimestampDate & Totals> = [];

  for (
    let tsCurrent = ts90DaysAgo;
    tsCurrent <= tsToday;
    tsCurrent = dayjs(tsCurrent).utc().add(1, "day").valueOf()
  ) {
    const found = data.find(item => item.date === tsCurrent) || {};
    const reducedTotals = Object.keys(found).reduce<Totals>((totals, key) => {
      if (key === stat) {
        return statReducer(totals, found[key]);
      }
      return totals;
    }, init());

    result.push({
      date: tsCurrent,
      ...reducedTotals,
    });
  }

  return result;
}
